import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiUserSharedService } from '@fi-shared/fi-user-shared/fi-user-shared.service';
import { ChooseBusinessUnitDialogComponent } from '@fi-shared/fi-user-shared/choose-business-unit-dialog/choose-business-unit-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import { FiDialogsModule } from '@fi-shared/fi-dialogs';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiUserHelperService } from '@fi-shared/fi-user-shared/fi-user-helper.service';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule, FiDialogsModule, MatSelectModule],
    declarations: [ChooseBusinessUnitDialogComponent],
    providers: [FiUserSharedService, FiUserHelperService],
})
export class FiUserSharedModule {}
